/* eslint-disable @typescript-eslint/no-explicit-any */
import apiRequest from 'helpers/apiRequest';

export const makeApiRequest = async (originalRequest: any) =>
  apiRequest(originalRequest);

export const onError = (error: {
  response: { error: unknown; message: string };
  message: string;
}) => {
  const errorData: any = error;
  if (errorData?.detail?.user_must_login) {
    localStorage.setItem('userMustLogin', 'YES');
    return Promise.resolve(errorData);
  }
  if (
    Array.isArray(errorData) ||
    (typeof errorData === 'object' && errorData !== null)
  ) {
    return Promise.resolve(errorData);
  }
  return Promise.resolve(errorData);
};

export const onSuccess = (response: { data: { data: unknown } }) => {
  let formattedData;
  const responseData: any = response?.data;

  if (Array.isArray(responseData)) {
    formattedData = responseData[0];
  } else if (typeof responseData === 'object' && responseData !== null) {
    formattedData = responseData;
  }
  return Promise.resolve(formattedData);
};

export const onSuccessFetch = (response: { data: { data: unknown } }) => {
  let formattedData;
  const responseData: any = response?.data;

  if (Array.isArray(responseData)) {
    formattedData = responseData;
  } else if (typeof responseData === 'object' && responseData !== null) {
    formattedData = responseData;
  }
  return formattedData;
};

export const requestPayload =
  ({ url, method }: { url?: string; method: string }) =>
  async (payload?: any) => {
    const originalRequest = {
      url,
      method,
      payload,
    };

    const response = await apiRequest(originalRequest);
    return response;
  };
